import axios from "axios";
import { ticketBaseURL } from "../../configs/api";

export const post_Checkout = async (data: any) => {
    const response = await axios({
        url: `${ticketBaseURL}rdRentalCheckout`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const post_RenewSubscription = async (data: any) => {
    const response = await axios({
        url: `${ticketBaseURL}rdRentalCheckout/RenewSubscription`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const post_UpgradeSubscription = async (data: any) => {
    const response = await axios({
        url: `${ticketBaseURL}rdRentalCheckout/UpgradeSubscription`,
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}
